import { render } from "./ModalTerminals.vue?vue&type=template&id=4e50295e"
import script from "./ModalTerminals.vue?vue&type=script&lang=js"
export * from "./ModalTerminals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__